import { render, staticRenderFns } from "./ProductFeedOfffer.vue?vue&type=template&id=5fa76025&lang=pug"
import script from "./ProductFeedOfffer.vue?vue&type=script&lang=js"
export * from "./ProductFeedOfffer.vue?vue&type=script&lang=js"
import style0 from "./ProductFeedOfffer.vue?vue&type=style&index=0&id=5fa76025&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports